module.exports = __webpack_public_path__ + "static/media/box-alt.05b96efc.svg";